import actionTypes from '../actionTypes';

export const updateSelectedMembers = (agentId, playerIdList) => ({
  type: actionTypes.UPDATE_SELECTED_MEMBERS,
  agentId,
  playerIdList,
});

export const updateSelectedMembersSuccess = () => ({
  type: actionTypes.UPDATE_SELECTED_MEMBERS_SUCCESS,
});

export const updateSelectedMembersFailure = () => ({
  type: actionTypes.UPDATE_SELECTED_MEMBERS_FAILURE,
});